import { ScheduleListPayload } from 'app/modules/schedule/payloads';

const BASE = ['schedules'] as const;

export const SCHEDULE_QUERY_KEYS = {
  getSchedule: (id: number) => [...BASE, 'schedule', id] as const,
  getScheduleList: (payload?: ScheduleListPayload) =>
    payload
      ? ([...BASE, 'schedule-list', payload] as const)
      : ([...BASE, 'schedule-list'] as const),
  getAllSchedules: () => [...BASE, 'all'] as const,
};
